import {
  GET_FOOD_ITEMS_ADMIN_REQUEST,
  GET_FOOD_ITEMS_ADMIN_SUCCESS,
  GET_FOOD_ITEMS_ADMIN_FAILURE,
  ADD_FOOD_ITEM_ADMIN_REQUEST,
  ADD_FOOD_ITEM_ADMIN_SUCCESS,
  ADD_FOOD_ITEM_ADMIN_FAILURE,
  UPDATE_FOOD_ITEM_ADMIN_REQUEST,
  UPDATE_FOOD_ITEM_ADMIN_SUCCESS,
  UPDATE_FOOD_ITEM_ADMIN_FAILURE,
  DELETE_FOOD_ITEM_ADMIN_REQUEST,
  DELETE_FOOD_ITEM_ADMIN_SUCCESS,
  DELETE_FOOD_ITEM_ADMIN_FAILURE,
  GET_VENDORS_ADMIN_REQUEST,
  GET_VENDORS_ADMIN_SUCCESS,
  GET_VENDORS_ADMIN_FAILURE,
} from "./actionType";
import {
  getFoodItemsAdminService,
  addFoodItemAdminService,
  updateFoodItemAdminService,
  deleteFoodItemAdminService,
  updateFoodItemStatusAdminService,
  getVendorsAdminService,
  updateVendorStatusService,
} from "../../config/services/employeeServices";
import ResponseFilter from "../../ResponseFilter";

// ── Get all food items (admin) ────────────────────────────────────────────────
const getFoodItemsAdmin = (params) => (dispatch) => {
  dispatch({ type: GET_FOOD_ITEMS_ADMIN_REQUEST });
  getFoodItemsAdminService(params)
    .then((res) => {
      let { status, resData } = ResponseFilter(res);
      if (status) {
        dispatch({ type: GET_FOOD_ITEMS_ADMIN_SUCCESS, payload: resData });
      } else {
        dispatch({ type: GET_FOOD_ITEMS_ADMIN_FAILURE, payload: res.data });
      }
    })
    .catch((err) => dispatch({ type: GET_FOOD_ITEMS_ADMIN_FAILURE, payload: err }));
};

// ── Add food item (admin) ─────────────────────────────────────────────────────
const addFoodItemAdmin = (params) => (dispatch) => {
  dispatch({ type: ADD_FOOD_ITEM_ADMIN_REQUEST });
  return addFoodItemAdminService(params)
    .then((res) => {
      let { status, resData } = ResponseFilter(res);
      if (status) {
        dispatch({ type: ADD_FOOD_ITEM_ADMIN_SUCCESS, payload: resData });
        return { success: true };
      } else {
        dispatch({ type: ADD_FOOD_ITEM_ADMIN_FAILURE, payload: res.data });
        return { success: false, message: res.data?.responseMessage };
      }
    })
    .catch((err) => {
      dispatch({ type: ADD_FOOD_ITEM_ADMIN_FAILURE, payload: err });
      return { success: false };
    });
};

// ── Update food item (admin) ──────────────────────────────────────────────────
const updateFoodItemAdmin = (params) => (dispatch) => {
  dispatch({ type: UPDATE_FOOD_ITEM_ADMIN_REQUEST });
  return updateFoodItemAdminService(params)
    .then((res) => {
      let { status, resData } = ResponseFilter(res);
      if (status) {
        dispatch({ type: UPDATE_FOOD_ITEM_ADMIN_SUCCESS, payload: resData });
        return { success: true };
      } else {
        dispatch({ type: UPDATE_FOOD_ITEM_ADMIN_FAILURE, payload: res.data });
        return { success: false, message: res.data?.responseMessage };
      }
    })
    .catch((err) => {
      dispatch({ type: UPDATE_FOOD_ITEM_ADMIN_FAILURE, payload: err });
      return { success: false };
    });
};

// ── Delete food item (admin) ──────────────────────────────────────────────────
const deleteFoodItemAdmin = (params) => (dispatch) => {
  dispatch({ type: DELETE_FOOD_ITEM_ADMIN_REQUEST });
  return deleteFoodItemAdminService(params)
    .then((res) => {
      let { status } = ResponseFilter(res);
      if (status) {
        dispatch({ type: DELETE_FOOD_ITEM_ADMIN_SUCCESS, payload: params });
        return { success: true };
      } else {
        dispatch({ type: DELETE_FOOD_ITEM_ADMIN_FAILURE, payload: res.data });
        return { success: false };
      }
    })
    .catch((err) => {
      dispatch({ type: DELETE_FOOD_ITEM_ADMIN_FAILURE, payload: err });
      return { success: false };
    });
};

// ── Get vendors list (admin — includes inactive) ──────────────────────────────
const getVendorsAdmin = (params) => (dispatch) => {
  dispatch({ type: GET_VENDORS_ADMIN_REQUEST });
  getVendorsAdminService(params)
    .then((res) => {
      let { status, resData } = ResponseFilter(res);
      if (status) {
        dispatch({ type: GET_VENDORS_ADMIN_SUCCESS, payload: resData });
      } else {
        dispatch({ type: GET_VENDORS_ADMIN_FAILURE, payload: res.data });
      }
    })
    .catch((err) => dispatch({ type: GET_VENDORS_ADMIN_FAILURE, payload: err }));
};

const toggleVendorStatus = (employeeId, currentStatus) => (dispatch) => {
  const newStatus = currentStatus === 1 ? 2 : 1;
  return updateVendorStatusService({ employeeId, status: newStatus })
    .then((res) => {
      let { status } = ResponseFilter(res);
      if (status) {
        dispatch(getVendorsAdmin());
        return { success: true };
      }
      return { success: false };
    })
    .catch(() => ({ success: false }));
};

export {
  getFoodItemsAdmin,
  addFoodItemAdmin,
  updateFoodItemAdmin,
  deleteFoodItemAdmin,
  getVendorsAdmin,
  toggleVendorStatus,
};
